<template>

    <div class="menu-wrapper has-text-grey-dark">

        <div class="menu-group" style="background-color:#ea93f8;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Numbers & Dates</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('modifiers/modify-number')" title="Perform basic math on numbers">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-plus"></i>/<i class="fa-solid fa-minus"></i></p>
                                <p class="is-size-7 has-text-weight-bold">MODIFY NUMBER</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('modifiers/modify-date')" title="Modify a given date">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-calendar-plus"></i></p>
                                <p class="is-size-7 has-text-weight-bold">MODIFY DATE</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('modifiers/round-date')" title="Round a date's day, week, month, or year up or down">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-calendar-day"></i></p>
                                <p class="is-size-7 has-text-weight-bold">ROUND DATE</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <div class="menu-group" style="background-color:#e7b3f3;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Text</p>
            </div>

            <div class="menu-group-items">

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('modifiers/concatenate-strings')" title="Concatenate texts">
                        <div class="has-text-grey-dark p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-a"></i>+<i class="fa-solid fa-b"></i></p>
                                <p class="is-size-7 has-text-weight-bold">ADD STRINGS</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </div>


</template>

<script>
export default {
    name: 'MenuTabModifiers',
    props: {
        triggerType: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        selected(type) {
            this.$emit('selected', type)
        }
    }
}
</script>

<style scoped lang="scss">
.menu-wrapper {
    overflow-x: auto;
    display: flex;
}
.menu-group {
    margin: 0 10px;
    padding: 10px;
    border-radius: 6px;

    .menu-group-title {
        width:100%;
        font-weight: bold;
        font-size: 1.5rem;
    }

    .menu-group-items {
        overflow-x: auto;
        display: flex;
    }

    &:first-child {
        margin-left: auto;
    }
    &:last-child {
        margin-right: auto;
    }
}
.menu-item {
    margin: 0 10px;

    & > div {
        padding: 0;
        height: 100px;
        width: 100px;
    }
}
.big-pretty-button {
    border: 0.5px solid #4a4a4a;
}
</style>
